module.exports = "/_next/static/images/why-gym-5060ed3be58b5e3207110a7add7024ca.jpg";